export default __webpack_public_path__ + "static/media/my_final_wishes.ea8d3102.pdf";